export default __webpack_public_path__ + "static/media/bx-plus (2).7b305166.svg";